"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultQuestionsAndSchema = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _zod = require("zod");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getSchema = (type, id, errorLabel, mandatoryErrorLabel, requireValidation) => {
  if (type === 'select') {
    return {
      [id]: _zod.z.object({
        displayValue: _zod.z.string().min(1, errorLabel),
        value: _zod.z.string()
      })
    };
  } else {
    return {
      [id]: requireValidation ? _zod.z.string().min(1, mandatoryErrorLabel) : _zod.z.string().optional()
    };
  }
};
var getInitialValue = (id, type, initialValue, options, hideInitialValue) => {
  if (type === 'select') {
    var _options;
    return {
      [id]: {
        displayValue: hideInitialValue ? '' : (_options = options === null || options === void 0 ? void 0 : options[parseInt(initialValue) - 1]) !== null && _options !== void 0 ? _options : '',
        value: hideInitialValue ? '' : initialValue !== null && initialValue !== void 0 ? initialValue : ''
      }
    };
  } else {
    return {
      [id]: hideInitialValue ? '' : initialValue
    };
  }
};
var defaultQuestionsAndSchema = (questions, errorLabel, mandatoryErrorLabel, displayMandatory, hideInitialValue) => {
  var requireValidation;
  var questionsSchemaObj = {},
    defaultQuestionsObj = {};
  questions && (questions === null || questions === void 0 ? void 0 : questions.forEach(question => {
    if (displayMandatory && question !== null && question !== void 0 && question.mandatory) {
      requireValidation = true;
    } else {
      requireValidation = false;
    }
    questionsSchemaObj = _objectSpread(_objectSpread({}, questionsSchemaObj), getSchema(question.type, question.id, errorLabel, mandatoryErrorLabel, requireValidation));
    defaultQuestionsObj = _objectSpread(_objectSpread({}, defaultQuestionsObj), getInitialValue(question.id, question.type, question.answer, question.options, hideInitialValue));
  }));
  return {
    questionsSchemaObj,
    defaultQuestionsObj
  };
};
exports.defaultQuestionsAndSchema = defaultQuestionsAndSchema;